import React from "react";

export default function PartnerKamiSection(){
    return (
        <div className="container-7">
            <div className="section-title text-center">
                <h2 className="text-header">Partner Kami</h2>
                <p>Kenali kekuatan kolaborasi kami melalui jaringan mitra yang telah terbukti dan beragam.</p>
            </div>

            <div className="partnership-wrapper">
                <div className="ui-g partnership-item">
                    <div className="ui-g-2 item">
                        <a href="https://pegadaian.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-PEGADAIAN.png')}
                                 alt="Pegadaian"/>
                        </a>
                    </div>
                    <div className="ui-g-2 item">
                        <a href="https://www.hibank.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-HIBANK.webp')} alt="hibank"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://www.jtrustbank.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-JTRUST.webp')} alt="JTrust"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://www.bankneocommerce.co.id/id/home" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-BNC.webp')} alt="BNC"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://bankraya.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-bank-raya.png')} alt='bankRaya'/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://banksaqu.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-BANKSAQU.webp')} alt="Bank Saqu"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://www.btpn.com/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-smbc.png')} alt='bankBTPN'/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://asliri.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-ASLIRI.webp')} alt="ASLI RI"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://www.bni.co.id/id-id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-BNI.webp')} alt="BNI"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://cbclik.com/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-click.png')} alt='cbClik'/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://digisign.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-DIGISIGN.webp')} alt="digisigns"/>
                        </a>
                    </div>

                    {/* <div className="ui-g-2 item">
                        <a href="https://www.e2pay.co.id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-e2pay.png')} alt='e2pay'/>
                        </a>
                    </div> */}

                    {/*<div className="ui-g-2 item">*/}
                    {/*    <a href="https://faspay.co.id/" target="_blank" rel="noreferrer">*/}
                    {/*        <img src={require('../../assets/img/partner-kami/logo-faspay.png')} alt='faspay'/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    <div className="ui-g-2 item">
                        <a href="https://fintech.id/id" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-FINTECHINDO.webp')}
                                 alt="fintech"/>
                        </a>
                    </div>

                    <div className="ui-g-2 item">
                        <a href="https://glair.ai/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-glair.png')} alt='glair'/>
                        </a>
                    </div>

                    {/* <div className="ui-g-2 item">
                        <a href="https://www.gudangvoucher.com/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-gvmoney.png')} alt='gvMoney'/>
                        </a>
                    </div> */}

                    <div className="ui-g-2 item">
                        <a href="https://www.jatis.com/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-jatis.png')} alt='jatis'/>
                        </a>
                    </div>

                    {/*<div className="ui-g-2 item">*/}
                    {/*    <a href="https://mekari.com/" target="_blank" rel="noreferrer">*/}
                    {/*        <img src={require('../../assets/img/partner-kami/logo-mekari.png')} alt='mekari'/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    <div className="ui-g-2 item">
                        <a href="https://simasinsurtech.com/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-SIMASINSURTECH.webp')}
                                 alt="SimasInsurtech"/>
                        </a>
                    </div>
                    <div className="ui-g-2 item">
                        <a href="https://vida.id/id/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/logo-vida.webp')}
                                 alt="SimasInsurtech"/>
                        </a>
                    </div>
                    <div className="ui-g-2 item">
                        <a href="https://advance.ai/" target="_blank" rel="noreferrer">
                            <img src={require('../../assets/img/partner-kami/LOGO-ADVANCEAI.png')}
                                 alt="Advance AI"/>
                        </a>
                    </div>

                    {/*<div className="item">*/}
                    {/*    <a href="https://www.doku.com/id-ID" target="_blank" rel="noreferrer">*/}
                    {/*        <img src={require('../../assets/img/landing-page/LOGO-DOKU.webp')} alt="DOKU"/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    {/*<div className="item">*/}
                    {/*    <a href="" target="_blank" rel="noreferrer">*/}
                    {/*        <img src={require('../../assets/img/landing-page/LOGO-UIB.webp')} alt="UIB"/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    {/*<div className="item">*/}
                    {/*    <a href="https://www.subex.com/" target="_blank" rel="noreferrer">*/}
                    {/*        <img src={require('../../assets/img/landing-page/LOGO-SUBEX.webp')} alt="Subex"/>*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
                <hr/>
                {/* <Divider type="solid" flexItem /> */}
                <div className="ui-g partof-section">
                    <div className="ui-g-3 item">
                        <p>Berizin dan diawasi oleh:</p>
                        <section className="flex"
                                 style={{width: '100%', justifyContent: 'left', marginTop: '25px'}}>
                            <a style={{textAlign: 'left'}} href="https://www.ojk.go.id/id/Default.aspx" target="_blank" rel="noreferrer">
                                {/*<img src={require('../../assets/img/partner-kami/LOGO-OJK.webp')} alt="OJK" />*/}
                                <p style={{margin: '0', fontWeight: '600'}}>Otoritas</p>
                                <p style={{margin: '0', fontWeight: '600'}}>Jasa</p>
                                <p style={{margin: '0', fontWeight: '600'}}>Keuangan</p>
                            </a>
                        </section>
                    </div>
                    <div className="ui-g-6 item">
                        <p>Anggota dari:</p>
                        <section className="flex">
                            <a href="https://www.afpi.or.id/" target="_blank" rel="noreferrer">
                                <img src={require('../../assets/img/partner-kami/logo-afpi.webp')} alt='logoAfpi1'/>
                            </a>
                            <a href="https://lapssjk.id/" target="_blank" rel="noreferrer">
                                <img src={require('../../assets/img/partner-kami/logo-laps-sjk.png')} alt='logoSjk'/>
                            </a>
                        </section>
                    </div>
                    <div className="ui-g-3 item">
                        <p>Sertifikasi:</p>
                        <section className="flex flex-row gap-1">
                            <img src={require('../../assets/img/partner-kami/ISO-27001.png')} alt="cbqa iso" style={{height: '110px'}}/>
                            <img src={require('../../assets/img/partner-kami/ISO-37001.png')} alt="cbqa iso"
                                 style={{height: '120px'}}/>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}